<div class="login-background w-full h-full bg-contain bg-left bg-no-repeat flex justify-center items-center">
  <div class="w-1/3">
    <div class="text-center flex justify-center items-center flex-col">
      <!--<div class="login-logo logo-min-size w-full max-w-xl"></div>-->
      <div class="logo-container ">
        <div class="logo align-middle"></div>
      </div>
    </div>
    <div class="flex justify-center flex-col items-center">
      <img *ngIf="_isCorrectLogin" src="../../../../assets/images/okGirl.png" alt="Ok" class="h-48" />
      <img *ngIf="!_isCorrectLogin" src="../../../../assets/images/koGirl.png" alt="Error" class="h-48" />
    </div>
  </div>
</div>
